export default "__VITE_ASSET__D98LRmQl__"